<template>
  <div class="book">
    <div class="page left">
      <h1>地の巻―兵法の道と云事</h1>
      <p class="kobun block"><strong>漢土和朝迄も、此道をおこなふものを、兵法達者と云傳たり。</strong></p>
      <p class="genndaibun">中国から日本に至るまで、この道を実践する者は、兵法に秀でた者と伝えられている。</p>

      <p class="kobun block"><strong>武士として、此法を学ばずと云事有べからず。</strong></p>
      <p class="genndaibun">武士である以上、この兵法を学ばないことはあり得ない。</p>

      <p class="kobun block"><strong>近代、兵法者と云て世をわたるもの、これハ劔術一通りの儀也。</strong></p>
      <p class="genndaibun">近年、兵法家と称して世を渡る者は、実際には剣術の一部分を知るにすぎない。</p>

      <p class="kobun block"><strong>常陸國鹿嶋かんとりの社人共、明神の傳として流々を立て、國々を廻り人に傳事、近き比の事也。</strong></p>
      <p class="genndaibun">常陸国の鹿島や香取の神社の神職たちは、神の教えとして様々な流派を作り、各地を巡って人々に教えることをしているが、これは近年のことである。</p>

      <p class="kobun block"><strong>いにしへより十能七藝とあるうちに、利方と云て、藝にわたるといへ共、</strong></p>
      <p class="genndaibun">古くから「十能七芸」と言われるが、その中に「利方」という技術があり、芸として伝わってきた。</p>

      <p class="kobun block"><strong>利方と云出すより、劔術一通りにかぎるべからず。</strong></p>
      <p class="genndaibun">しかし、「利方」を語るならば、それを剣術のみに限定してはならない。</p>

      <p class="kobun block"><strong>劔術一へんの利までにてハ、劔術もしりがたし。勿論、兵の法にハ叶べからず。</strong></p>
      <p class="genndaibun">剣術の表面的な技のみを求めるだけでは、剣術そのものを理解することすら難しい。ましてや、兵法には到底及ばない。</p>

      <p class="kobun block"><strong>世の中を見るに、諸藝をうり物に仕立、わが身をうり物の様に思ひ、諸道具に付ても、</strong></p>
      <p class="genndaibun">世の中を見渡せば、多くの芸事が商品として扱われ、人は自分自身を売り物のように考えている。また、道具についても、</p>

      <p class="kobun block"><strong>うり物にこしらゆる心、花實の二つにして、花よりも実のすくなき所也</strong></p>
      <p class="genndaibun">商品化しようとする心は、花と実の関係のようなもので、花はたくさんあれども実は少ないのが現状である。</p>

      <p class="kobun block"><strong>とりわき此兵法の道に、色をかざり花をさかせて、術をてらし、或ハ一道場、二道場など云て、</strong></p>
      <p class="genndaibun">特に兵法の道においては、派手に飾り立て、華々しく技を誇示し、または「第一道場」「第二道場」などと称して、</p>

      <p class="kobun block"><strong>此道をおしへ、此道を習て利を得んと思事、誰か謂、なまへいほう大きずのもと、誠なるべし。</strong></p>
      <p class="genndaibun">この道を教えたり学んだりすることで利益を得ようとする者がいる。誰が言ったかは知らないが、「軽薄な兵法は大きな災いの元」とはまさにその通りである。</p>

      <p class="kobun block"><strong>凡、人の世をわたる事、士農工商とて四の道也。</strong></p>
      <p class="genndaibun">そもそも、人が世を渡る道には、士・農・工・商の四つがある。</p>

      <p class="kobun block"><strong>一にハ農の道。</strong></p>
      <p class="genndaibun">第一は、農の道である。</p>

      <p class="kobun block"><strong>農人ハ、色々の農具をまうけ、四季轉変のこゝろへ暇なくして、春秋を送る事、是農の道也。</strong></p>
      <p class="genndaibun">農民は様々な農具を揃え、四季の移り変わりに対応しながら、休むことなく作業を行い、一年を過ごしていく。これが農の道である。</p>

      <p class="kobun block"><strong>二にハ商の道。</strong></p>
      <p class="genndaibun">第二は、商の道である。</p>

      <p class="kobun block"><strong>酒を作るものハ、それぞれの道具を求め、其善悪の利を得て、とせいを送る。</strong></p>
      <p class="genndaibun">酒を造る者は、それぞれの道具を揃え、品質の良し悪しを見極めながら生計を立てている。</p>

      <p class="kobun block"><strong>何もあきなひの道、其身其身のかせぎ、其利を以て世をわたる、是商の道也。</strong></p>
      <p class="genndaibun">商売の道とは、それぞれが自らの商いを営み、その利益によって世を渡ることである。これが商の道である。</p>

      <p class="kobun block"><strong>三にハ士の道。</strong></p>
      <p class="genndaibun">第三は、士の道である。</p>

      <p class="kobun block"><strong>武士におゐてハ、さまざまの兵具をこしらへ、兵具品々の徳をわきまへたらんこそ、武士の道なるべけれ。</strong></p>
      <p class="genndaibun">武士は様々な兵具を備え、それぞれの特性を理解してこそ、真の武士の道といえる。</p>

      <p class="kobun block"><strong>兵具をもたしなまず、其具其具の利をも覚へざる事、武家ハ、少々たしなミの淺きものか。</strong></p>
<p class="genndaibun">武器に興味を持たず、それぞれの武器の利点を理解しないことは、武士としての修養が浅いと言えるだろう。</p>

<p class="kobun block"><strong>四には工の道。</strong></p>
<p class="genndaibun">第四は「工」の道である。</p>

<p class="kobun block"><strong>大工の道におゐてハ、種々様々の道具をたくみこしらへ、其具其具を能つかひ覚へ、</strong></p>
<p class="genndaibun">大工の道においては、様々な道具を工夫して作り、それらを巧みに使いこなせるよう習得する。</p>

<p class="kobun block"><strong>すみかねをもつて、其指圖をたゞし、暇もなく其わざをして、世をわたる。</strong></p>
<p class="genndaibun">墨縄を用いて設計を正し、常にその技を磨きながら生計を立てていく。</p>

<p class="kobun block"><strong>是士農工商、四の道也。</strong></p>
<p class="genndaibun">これが士・農・工・商の四つの道である。</p>

<p class="kobun block"><strong>兵法を、大工の道にたとへて云顕す也。大工にたとゆる事、家と云事に付ての儀也。</strong></p>
<p class="genndaibun">兵法を大工の道に例えて説明するのは、「家」という概念と関係があるからである。</p>

<p class="kobun block"><strong>公家、武家、四家、其家の破れ、家のつゞくと云事、其流、其風、其家などゝいへバ、</strong></p>
<p class="genndaibun">公家、武家、そして四つの家において、その家が滅びるか、続くかということ、また、その流派や風格、家柄などを考えたとき、</p>

<p class="kobun block"><strong>家と云より、大工の道にたとへたり。</strong></p>
<p class="genndaibun">「家」というものを考えると、それは大工の道と関連付けられる。</p>

<p class="kobun block"><strong>大工は、大にたくむと書くなれバ、兵法の道、大なるたくミによつて、大工に云なぞらへて書顕す也。</strong></p>
<p class="genndaibun">「大工」は「大きく工夫する」と書く。兵法の道もまた、大いなる工夫によって成り立つため、大工の道に例えて書き表しているのである。</p>

<p class="kobun block"><strong>兵の法を学ばんと思はゞ、此書を思案して、</strong></p>
<p class="genndaibun">もし兵法を学びたいのであれば、この書をよく考えながら読むべきである。</p>


      <p class="kobun block"><strong>師は針、弟子は糸となつて、たへず稽古有べき事也。</strong></p>
      <p class="genndaibun">師は針のように鋭く導き、弟子は糸のようにそれに従い、絶えず鍛錬を続けなければならない。</p>
    </div>
    <div class="page right">
      <div class="video"><div class = "video-container"><iframe  src="https://www.youtube.com/embed/XVh58ItKRPA" frameborder="0" allowfullscreen></iframe></div></div>
      <h2>地之卷-论兵法之道</h2>

      <p class="kobun block"><strong>自汉土至我邦，有能行此道者，谓之兵法达者</strong></p>
      <p class="genndaibun">从中国到日本，能够精通兵法之道的人，被称为“兵法达人”。</p>

      <p class="kobun block"><strong>凡为武士，岂有不学此法者哉？</strong></p>
      <p class="genndaibun">作为武士，不学习兵法是不可想象的</p>

      <p class="kobun block"><strong>近代有自称兵法者而渡世者，此仅劒术一途耳。</strong></p>
      <p class="genndaibun">近来有些人自称兵法家，实际上只不过是精通剑术而已。</p>

      <p class="kobun block"><strong>常陆国鹿岛香取之社人，云明神所传，立诸流派，周游列国而授人，乃近代之事也。</strong></p>
      <p class="genndaibun">常陆国鹿岛、香取的神社人士宣称自己得到了神灵传授，建立了各类流派，游历各地传授技艺，这些事情主要出现在近代。</p>

      <p class="kobun block"><strong>古人云“十能七艺”，近代之兵法者，称其为“利方”，以剑术之艺渡世。</strong></p>
      <p class="genndaibun">自古以来有“十能七艺”的说法，然而现代的兵法者宣称所谓的“利方”，只把剑术作为手段来谋生。</p>

      <p class="kobun block"><strong>然若言“利方”，则不应仅限于剑术一项。</strong></p>
      <p class="genndaibun">如果要主张“利方”，就不应只局限于剑术。</p>
      
      <p class="kobun block"><strong>若止于剑术一端之“利”，则即便是剑术，亦难以知其奥义。更不用说，它无法符合兵法的全貌。</strong></p>
      <p class="genndaibun">如果只追求剑术上的“利”，即使是剑术本身也难以精通。更何况，它无法与兵法的整体理念相符合。</p>
      
      <p class="kobun block"><strong>观世间，种种艺事皆为卖物，自视为商品，连道具亦为出售之物。</strong></p>
      <p class="genndaibun">观察世间，人们将各种技艺当作商品，自己也视为商品，甚至将工具也视作可以出售的物品。</p>
      
      <p class="kobun block"><strong>此等心态，若分花与实，则花虽多，实则少</strong></p>
      <p class="genndaibun">这种心态，如果分成花和果两部分，花虽然多，但果实却很少。</p>

      <p class="kobun block"><strong>尤为此兵法之道，装饰色彩，开花作秀，炫耀技艺，或称第一道场、第二道场等，</strong></p>
      <p class="genndaibun">尤其在兵法的道路上，有些人装饰外表，炫耀技巧，或者称自己为第一道场、第二道场等</p>

      <p class="kobun block"><strong>教此道，或习此道，意欲从中得利。谁人言：“草率的兵法，是大祸之源”，正是此意。</strong></p>
      <p class="genndaibun">教授这门技艺，或者学习它，想着从中获利。正如有人所说，“草率的兵法，是大祸的根源”，这正是指的这种情况。</p>

      <p class="kobun block"><strong>凡人之所以立世者，有“四道”：士、农、工、商，四者也。</strong></p>
      <p class="genndaibun">大体来说，人们在社会上生活，有四种方式，分别是士人、农民、工匠和商人。</p>
      
      <p class="kobun block"><strong>一者，农之道也。</strong></p>
      <p class="genndaibun">其中之一是“农”的道路。</p>

      <p class="kobun block"><strong>农民设有种种农具，常怀警觉，以应四时气候之变，日月不懈，斯为农道也。</strong></p>
      <p class="genndaibun">农民设置了各种农具，时刻注意四季气候的变化，日复一日地劳作，这就是农业之道。</p>

      <p class="kobun block"><strong>二者，商之道也。</strong></p>
      <p class="genndaibun">其次是“商”的道路。</p>

      <p class="kobun block"><strong>酿酒者，求其器具，凭商品之优劣获利，渡世为生</strong></p>
      <p class="genndaibun">酿酒的人会根据自己的需求寻找相应的工具，通过商品的好坏来获利，从而维持生活</p>

      <p class="kobun block"><strong>凡商贾，各依其业，以利为生，渡世之道也。</strong></p>
      <p class="genndaibun">任何商人都会依靠自己的行业，通过赚取利润来维持生活，这就是商道。</p>

      <p class="kobun block"><strong>三者，士之道也。</strong></p>
      <p class="genndaibun">第三是“士”的道。</p>

      <p class="kobun block"><strong>武士者，造兵器，各兵具之徳，通晓之，乃武士之道也。</strong></p>
      <p class="genndaibun">在武士中，制造各种武器，了解每种兵器的特性，才是武士的道。</p>

      <p class="kobun block"><strong>若无兵具之嗜好，亦不知其利，武家者，嗜好浅薄者也。</strong></p>
      <p class="genndaibun">如果没有对兵器的兴趣，也不懂得每种兵器的优点，那么武士的修养就显得有些浅薄了。</p>

      <p class="kobun block"><strong>四者，工之道。</strong></p>
      <p class="genndaibun">第四种是“工”的道。</p>

      <p class="kobun block"><strong>大工之道，设种种器具，巧工制成，善用之，习熟之。</strong></p>
      <p class="genndaibun">在大工的道中，制作各种各样的工具，学会熟练使用每一件工具</p>

      <p class="kobun block"><strong>以墨矩考察指図，常做其事，渡世以之。</strong></p>
      <p class="genndaibun">使用墨矩进行设计考量，并不断从事这项工作，以此度过一生。</p>

      <p class="kobun block"><strong>此四者，乃「士農工商」四道也。</strong></p>
      <p class="genndaibun">这些就是“士农工商”四个道。</p>

      <p class="kobun block"><strong>兵法者，喩大工之道也。喻大工者，以「家」为关联也。</strong></p>
      <p class="genndaibun">兵法之所以比作大工之道，是因为它与“家”相关联。</p>

      <p class="kobun block"><strong>公家、武家、四家。其家之破灭、家之存续，或其流，或其风，或其家等是也。</strong></p>
      <p class="genndaibun">公家、武家、四家等家族的破灭与存续，或者是其传承、风格、家族等方面的事宜。</p>

      <p class="kobun block"><strong>公故以家之事，喻大工之道。</strong></p>
      <p class="genndaibun">因此，将家族之事与大工之道相比较。</p>

        
      <p class="kobun block"><strong>大工者，书曰“大以谋”。是故，兵法之道，亦以大谋为本，故喻之以大工之道。</strong></p>
      <p class="genndaibun">大工被写作“大以谋”。因此，兵法的道理也以大的谋划为根本，所以用大工之道来做类比。</p>

        
      <p class="kobun block"><strong>若欲学兵法者，当读此书</strong></p>
      <p class="genndaibun">如果想学习兵法，就应该读这本书并仔细思考</p>

        
      <p class="kobun block"><strong>师如针，弟子如线，须恒心练习，不可懈怠。</strong></p>
      <p class="genndaibun">老师像针一样，学生像线一样，必须不断地练习，不能懈怠
      </p>

    </div>
  </div>
</template>

<style lang="scss">
@import "./fiveRingsCss.scss";
</style>
